import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getSpecialdonation, editSpecialdonation } from "../../store/actions/specialdonations_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import { initialValues, inputFields } from "../../shared/enums/specialdonations_enum";

const EditSpecialdonation = ({ editSpecialdonation, getSpecialdonation, match, specialdonation: { loading, specialdonation } }) => {
    let history = useHistory();
    useEffect(() => {
        getSpecialdonation(match.params.id);
    }, [match]);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [gallery, setGallery] = useState(null);
    const submitSpecialdonation = async (values) => {
        if (featuredImage || gallery) {
            const images = await upload(featuredImage, gallery);
            if (images) {
                if (images.featured_image) {
                    values.featured_image = images.featured_image;
                }
                if (images.gallery_images) {
                    values.gallery = images.gallery_images;
                }
            }
        }
        await editSpecialdonation(specialdonation.id, values);
        history.push(`/specialdonations/${specialdonation.id}/view`);
    };

    return (
        <div className="pace-done">
            <div>
                <Header />
                <BreadCrumb
                    title="Edit Specialdonation"
                    mainLinkTitle="Specialdonations"
                    mainLinkUrl="/specialdonations"
                    activeLink="Edit"
                />
            </div>
            <div className="container-fluid">
                <div className="col-lg-12">
                    <div className="card">
                        {!loading ? (
                            specialdonation && (
                                <div>
                                    <div className="card-header">
                                        <div>
                                            <h4 className="card-title">
                                                {specialdonation.title} - <span>Edit</span>{" "}
                                            </h4>
                                            <p className="card-title-desc">
                                                <Link to="/specialdonations" className="btn btn-soft-light">
                                                    <i className="fa fa-angle-left"></i> Specialdonations
                                                </Link>
                                                <Link
                                                    to={`/specialdonations/${specialdonation.id}/view`}
                                                    className="btn btn-soft-light"
                                                >
                                                    <i className="fa fa-eye"></i>
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                    <AddForm
                                        data={specialdonation}
                                        edit={true}
                                        featuredImage={featuredImage}
                                        gallery={gallery}
                                        setFeaturedImage={setFeaturedImage}
                                        setGallery={setGallery}
                                        submitForm={submitSpecialdonation}
                                        inputFields={inputFields}
                                        initialValues={initialValues}
                                    />
                                </div>
                            )
                        ) : (
                            <div className="text-center">
                                <Spinner />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    alert: state.alert,
    specialdonation: state.specialdonation,
});

const mapDispatchToProps = { editSpecialdonation, getSpecialdonation };

export default connect(mapStateToProps, mapDispatchToProps)(EditSpecialdonation);
